import { Sorts } from './models/sorts.type';

export function objectValidation(value: any): Object | undefined {
  if (typeof value !== 'string') return undefined;

  return JSON.parse(value) as Object;
}

export function stringValidation(value: any): string | undefined {
  if (typeof value !== 'string') return undefined;

  return value as string;
}

export function numberValidation(value: any): number | undefined {
  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) return undefined;

  return numberValue;
}

export function booleanValidation(value: any): boolean | undefined {
  if (value === 'true' || value === 'false') return (value === 'true') as boolean;

  return undefined;
}

export function sortValidation(value: any): Sorts | undefined {
  if (typeof value !== 'string') return undefined;

  const parsed = JSON.parse(value);
  const keys = Object.keys(parsed);

  if (keys.length !== 2) return undefined;

  if (!keys.includes('field') || !keys.includes('order')) return undefined;

  if (parsed.order !== 'ASC' && parsed.order !== 'DESC') return undefined;

  return parsed as Sorts;
}
